import "bootstrap/dist/css/bootstrap.css";
import React from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import App from "./App.tsx";
import { installAuthInterceptor } from "./api/auth.ts";

// /api/files への fetch に認証トークンを自動付与する（描画前に設定）
installAuthInterceptor();

const baseUrl = document.getElementsByTagName("base")[0].getAttribute("href");
const rootElement = document.getElementById("root");
const root = createRoot(rootElement!); // ! は「nullではない」とTSに教える記号

root.render(
  <BrowserRouter basename={baseUrl ?? undefined}>
    <App />
  </BrowserRouter>
);
